import React, { FC, useContext } from "react";
import { ICellRendererParams } from "ag-grid-community";
import { downloadHandler, useHealthScoreColor } from "utils";
import { AxiosInstance } from "axios";
import { useRouter } from "next/router";
import { useAccountById } from "components/summary/hooks";
import { IconButton } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { AuthProvider } from "pages";
import { ROLE } from "constant";
import { Site } from "types/portfolio";
import { round } from "lodash";
import { classHOC } from "components/app/ClassWrapper";

const useStyles = makeStyles(() => ({
  pdfButton: {
    marginRight: 26,
    padding: 8,
  },
  activePdf: {
    backgroundColor: "#F7644A",
    "&:hover": {
      backgroundColor: "#F7644A",
    },
  },
  disabledPdf: {
    backgroundColor: "#898989",
    "&:hover": {
      backgroundColor: "#898989",
    },
  },
}));

const HealthScoreRenderer: FC<
  ICellRendererParams & {
    type?: string;
    axios?: AxiosInstance;
    cellData?: Site[];
    accountType?: string;
  }
> = ({ data, type, axios, node, cellData, accountType }) => {
  const classes = useStyles();
  const { healthScore, siteName, sites } = data ?? {};
  const router = useRouter();
  const { data: account } = useAccountById(router.query.accountId as string);
  const authDetail = useContext(AuthProvider);

  const onReportClick = (siteName: string) => () => {
    if (axios) {
      downloadHandler(axios, "Health Report Download", "/api/summary/health-report", {
        siteName,
        company: account?.accountName,
      });
    }
  };

  if (node.rowPinned) return null;

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent:
          type === "download" && authDetail.role !== ROLE.PARTNER_ROLE ? "space-around" : "center",
      }}
    >
      <>
        {healthScore >= 0 && healthScore !== null ? (
          <span
            style={{
              color: useHealthScoreColor(healthScore),
            }}
          >
            {round(healthScore, 1)}%
          </span>
        ) : (
          <span>
            {data?.siteKey || data?.ciOrgId || sites.length
              ? cellData?.length
                ? "N/A"
                : "Not Available"
              : "Not Available"}
          </span>
        )}
        {type === "download" &&
        authDetail.role !== ROLE.PARTNER_ROLE &&
        !accountType?.toLowerCase()?.includes("online") ? (
          siteName ? (
            <IconButton
              size="small"
              className={`${classes.pdfButton} ${classes.activePdf}`}
              onClick={onReportClick(siteName)}
            >
              <i
                className={`cui-icon icon icon-file-pdf_16 `}
                style={{ color: "white" }}
              />
            </IconButton>
          ) : (
            <IconButton
              size="small"
              disabled
              style={{ backgroundColor: "grey" }}
              className={`${classes.pdfButton} ${classes.disabledPdf}`}
            >
              <i
                className={`cui-icon icon icon-file-pdf_16 `}
                style={{ color: "white" }}
              />
            </IconButton>
          )
        ) : null}
      </>
    </div>
  );
};

export default classHOC(HealthScoreRenderer);
